import React, { useMemo, useState } from "react";
import spacetime from "spacetime";
import TimezoneSelect, { allTimezones } from "react-timezone-select";
import {getTimeZone, setTimeZone} from "../../api/timeZone";

export default function TimeZone() {
    const [tz, setTz] = useState(
        getTimeZone() || Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    const [datetime, setDatetime] = useState(spacetime.now());

    const onChange = (tz) => {
        setTimeZone(tz)
        setTz(tz)
    }

    useMemo(() => {
        const tzValue = tz.value ?? tz;
        setDatetime(datetime.goto(tzValue));
    }, [tz]);

    return (
        <TimezoneSelect
            value={tz}
            onChange={onChange}
            labelStyle="altName"
            timezones={{
                ...allTimezones,
                "America/Lima": "Pittsburgh",
                "Europe/Berlin": "Frankfurt"
            }}
        />
    );
}
